var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGuidewire = function SvgGuidewire(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1440 1443"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".guidewire_svg__s0{fill:#00739d}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "guidewire_svg__Layer"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1439.9 289.4V.6H.8v1441.8h862.7v-288.8H289V289.4z",
    className: "guidewire_svg__s0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1439.9 578.1v864.3h-288.2V864.9H575.3V578.1z",
    className: "guidewire_svg__s0"
  }))));
};
export default SvgGuidewire;